import { jsx } from 'react/jsx-runtime';
import React from 'react';
import styled from 'styled-components';
import '../Navbar/index.js';
import '../Banner/index.js';
import { Navbar } from '../Navbar/Navbar.js';
import { useBanner } from '../Banner/context/useBanner.js';

const StyledHeader = styled.header `
  width: 100%;
  top: 0;
  z-index: ${({ theme }) => theme.zIndex[4]};

  /* Have the fixed as safeguard for older browsers */
  position: fixed;
  position: sticky;

  ${({ hideShadow }) => hideShadow &&
    `
    ${Navbar} {
      box-shadow: none;
    }
  `}
`;
const Header = React.forwardRef(function Header({ children, className }, ref) {
    const { items } = useBanner();
    return (jsx(StyledHeader, Object.assign({ className: className, ref: ref, hideShadow: items.length > 0 }, { children: children })));
});

export { Header };
